import { StringParam, UrlUpdateType, useQueryParam } from "use-query-params";
import { kioskFacilityId } from "../../../globalContext";

export const useFacilityIdParam = (): [string | undefined | null, (newValue: string, updateType?: UrlUpdateType | undefined) => void] => {
    const [facilityIDParam, setFacilityIDParam] = useQueryParam('facilityId', StringParam);
    const cleanedFacilityIdParam = facilityIDParam?.split('?')?.[0]

    return [kioskFacilityId || cleanedFacilityIdParam, setFacilityIDParam];
};
